import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Placeholder, Grid, Header, Icon, Breadcrumb, Segment, Input } from 'semantic-ui-react';
import moment from 'moment';
import { usePublicEmployerSpotlightPresentation } from './usePublicEmployerSpotlightPresentationList';
import { SimplePageBar } from '../../Common/CommonComponents/SimplePageBar';


export function PublicEmployerSpotlightPresentation() {

    const [recordsPerPage, totalRecords, pageNum,
        pageSizeOptions, searchRef, searchText, data, isLoading, sortOrderDesc, sortByField,
        handlePageSizeChange, handleSearchChange, resetSearch, handlePaginationChange, handleSortChange] = usePublicEmployerSpotlightPresentation();

    const totalPages: number = Math.ceil(totalRecords / recordsPerPage);
    const hasNext: boolean = !(pageNum >= totalPages);
    const hasPrev: boolean = pageNum > 1;

    const handlePrevPage = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        handlePaginationChange(pageNum - 1);
    }

    const handleNextPage = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        handlePaginationChange(pageNum + 1);
    }


    console.log(data);
    return (
        <Container className='dashboard-container'>
            <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Employer Spotlight Presentation</Header>
            <hr />
            <Breadcrumb>
                <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section active>Employer Spotlight Presentation</Breadcrumb.Section>
            </Breadcrumb>
            <SimplePageBar
                handlePrevActive={handlePrevPage}
                handleNextActive={handleNextPage}
                hasNext={hasNext}
                hasPrev={hasPrev}
            />
            <Segment basic style={{ padding: 0 }}>
                {
                    isLoading &&
                    <div>
                        <Header as='h2' attached='top' inverted className='ESP-list'>
                            <Placeholder fluid inverted>
                                <Placeholder.Line />
                            </Placeholder>
                        </Header>
                        <Segment attached>
                            <Placeholder fluid>
                                <Placeholder.Header image>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Header>
                                <Placeholder.Paragraph>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Paragraph>
                            </Placeholder>
                        </Segment>
                    </div>
                }
                {
                    !isLoading && data && data.length >= 1 &&
                    data.map((dataRow, rowIndex) => {
                        return (
                            <div key={rowIndex}>
                                <Header as='h2' attached='top' inverted className='ESP-list'>
                                    {moment(dataRow.date).format('dddd, MMM D, YYYY')}
                                </Header>
                                <Segment attached basic style={{ border: 'none' }}>
                                    {
                                        dataRow.data && dataRow.data.length >= 1 &&
                                        dataRow.data.map((eventData:any, eventIndex: any) => {
                                            return (
                                                <Grid key={eventIndex}>
                                                    <Grid.Row style={{paddingTop: '1.5rem', paddingBottom: '1.5rem'}}>
                                                        <Grid.Column mobile={16} tablet={3} computer={3}>
                                                            {moment(eventData.startTime).format('hh:mm A')}
                                                        </Grid.Column>
                                                        <Grid.Column mobile={16} tablet={13} computer={13}>
                                                            <Link
                                                                to={`/bookESPSpot/${eventData.employerSpotlightPresentationId}`}
                                                                title='Click to book a spot.'
                                                            >{eventData.organization + ' - ' + eventData.topic}</Link>
                                                            {
                                                                eventData.description &&
                                                                <p>{eventData.description}</p>
                                                            }
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            );
                                        })
                                    }
                                </Segment>
                            </div>
                        );
                    })
                }
            </Segment>
            <SimplePageBar
                handlePrevActive={handlePrevPage}
                handleNextActive={handleNextPage}
                hasNext={hasNext}
                hasPrev={hasPrev}
            />
        </Container>
    );
}